import React from 'react';
import { Table } from '@bynder/design-system';
import useAccessRights from 'packages/hooks/useAccessRights';
import { getCollectionSharingIcon } from 'packages/pages/components/card/utils';
import CategoryThumbnail from 'packages/pages/categoryDetails/components/CategoryThumbnail';
import { Category } from 'packages/store/categories/types';
import { Box } from './TitleCell.styled';

const CategoryTitleCell = ({
    category,
    includeSharedIndicator,
}: {
    category: Category;
    includeSharedIndicator?: boolean;
}) => {
    const { getIdentityRole, getIdentityRoleAllUsers } = useAccessRights();

    return (
        <Table.Cell thumbnail={<CategoryThumbnail category={category} />}>
            <Box style={{ position: 'relative' }}>
                <div>{category.name}</div>
                <div>
                    {includeSharedIndicator &&
                        getCollectionSharingIcon(category, { getIdentityRole, getIdentityRoleAllUsers })}
                </div>
            </Box>
        </Table.Cell>
    );
};

export default CategoryTitleCell;
